<template>
  <div class>
    <Toast />

    <div class="card">
      <h5>
        <b>Buat Permintaan Barang Obral</b>
      </h5>
      <div class="p-grid p-fluid">
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead>
              <th>Barang</th>
              <th>Tersedia</th>
              <th>Jumlah</th>
              <th></th>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k">
                <td>
                  <AutoComplete
                    placeholder="Kode"
                    :dropdown="true"
                    :multiple="false"
                    v-model="an_item.selected_item"
                    :suggestions="autoFiltered"
                    @complete="getItems"
                    @input="chooseDropdownChanges(k)"
                    field="code"
                  >
                    <template #item="slotProps">
                      <div>{{ slotProps.item.name }}</div>
                      <div style="font-style: italic; font-size: 12px">
                        {{ slotProps.item.code }}
                      </div>
                    </template>
                  </AutoComplete>
                  <small class="p-error" v-if="isError.items[k].id">{{
                    error_msg.items[k].id
                  }}</small>
                </td>
                <td>
                  <InputText
                    :disabled="true"
                    v-model="an_item.stock"
                    placeholder="Stock"
                  />
                </td>
                <td>
                  <InputText
                    type="number"
                    v-model="an_item.qty"
                    placeholder="0"
                    min="1"
                    @keyup.prevent="qtyChanges(k)"
                    @change="qtyChanges(k)"
                  />
                  <small class="p-error" v-if="isError.items[k].qty">{{
                    error_msg.items[k].qty
                  }}</small>
                </td>
                <td scope="row" class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <Button
                    icon="pi pi-plus"
                    label="Tambah"
                    class="p-mr-2"
                    @click="addNewRow"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="p-grid p-justify-center">
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="saveChanges"
            :disabled="loading.createButton"
          >
            Buat
            <span v-if="loading.createButton">
              <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      autoFiltered: [],
      items_checked: false,
      isError: {
        doc_number: false,
        doc_date: false,
        items: [{ id: false, qty: false }]
      },
      error_msg: {
        doc_number: '',
        doc_date: '',
        items: [{ id: '', qty: '' }]
      },
      items: [],
      total_price: 0,
      items_temp: [
        {
          selected_item: '',
          name: null,
          stock: null,
          qty: null
        }
      ],
      inputData: {
        warehouse_sales: [
          {
            item_id: 0,
            qty: 0
          }
        ]
      },
      loading: {
        createButton: false
      }
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems(event) {
      let code = ''
      if (event.query != null) {
        code = event.query
      } else {
        code
      }
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            let query = event.query
            let autoFiltered = []
            for (let i = 0; i < this.items.length; i++) {
              let item = this.items[i]
              if (item.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                autoFiltered.push(item)
              } else if (
                item.code.toLowerCase().indexOf(query.toLowerCase()) === 0
              ) {
                autoFiltered.push(item)
              }
            }
            this.autoFiltered = autoFiltered
          }
        })
    },

    chooseDropdownChanges(index) {
      if (this.items_temp[index].selected_item instanceof Object) {
        this.isError.items[index].id = false
        this.items_temp[index].stock =
          this.items_temp[index].selected_item.stock

        this.calculateLineTotal(index)
      }
    },

    qtyChanges(index) {
      this.isError.items[index].qty = false
      this.calculateLineTotal(index)
    },

    calculateLineTotal(index) {
      let qty = 0
      if (this.items_temp[index].qty) {
        qty = parseInt(this.items_temp[index].qty)
      }

      this.items_temp[index].total = qty * this.items_temp[index].price
      this.calculateTotal()
    },

    calculateTotal() {
      this.total_price = this.items_temp.reduce(function (sum, item) {
        return sum + item.total
      }, 0)
    },

    saveChanges() {
      this.inputData = {
        warehouse_sales: []
      }
      for (var i = 0; i < this.items_temp.length; i++) {
        if (
          this.items_temp[i].selected_item.id == '' ||
          this.items_temp[i].selected_item.id == null
        ) {
          this.isError.items[i].id = true
          this.error_msg.items[i].id = 'Select item first'
          return
        }

        if (this.items_temp[i].qty > this.items_temp[i].stock) {
          this.$toast.add({
            severity: 'error',
            summary: 'Pembuatan Barang Obral Gagal',
            detail: 'Stok tidak mencukupi',
            life: 3000
          })
          return
        }

        if (
          this.items_temp[i].qty <= 0 ||
          this.items_temp[i].qty == '0' ||
          this.items_temp[i].qty == null
        ) {
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'Quantity must be greater than 0'
          return
        }

        this.inputData.warehouse_sales.push({
          item_id: this.items_temp[i].selected_item.id,
          qty: +this.items_temp[i].qty
        })
      }
      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales`,
          this.inputData
        )
        .then(response => {
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Pembuatan Barang Obral Berhasil',
              detail: 'Barang Obral telah barhasil dibuat',
              life: 3000
            })
            this.items_temp = [
              {
                selected_item: '',
                name: null,
                qty: null
              }
            ]
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Pembuatan Barang Obral Gagal',
              detail: 'Barang obral tidak berhasil dibuat',
              life: 3000
            })
          }
        })
    },

    deleteRow(index, an_item) {
      var idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
      }
      this.calculateTotal()
    },
    addNewRow() {
      this.items_temp.push({
        // code: '',
        selected_item: '',
        name: '',
        price: 0,
        qty: null,
        total: 0
      })
      this.isError.items.push({ id: false, qty: false })
      this.error_msg.items.push({ id: '', qty: '' })
    }
  }
}
</script>

<style scoped></style>
